export default __webpack_public_path__ + "static/media/Play.dd4fa2ec.svg";